module.exports = __webpack_public_path__ + "static/media/tendercase04.aa25163b.png";